// extracted by mini-css-extract-plugin
export default {"popover":"IconTooltipWrapper_popover__fE9y-","tooltipBody":"IconTooltipWrapper_tooltipBody__6S-we","popover-body":"IconTooltipWrapper_popover-body__G3J51"};